import { render, staticRenderFns } from "./omCallerLog.vue?vue&type=template&id=272f9f9d"
import script from "./omCallerLog.ts?vue&type=script&lang=js&external"
export * from "./omCallerLog.ts?vue&type=script&lang=js&external"
import style0 from "./omCallerLog.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports